import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, refreshUser } = useAuth();
  const location = useLocation();
  const [authChecked, setAuthChecked] = useState(false);
  const [validSession, setValidSession] = useState(null);

  useEffect(() => {
    if (loading || isAuthenticated) {
      setAuthChecked(true);
      setValidSession(isAuthenticated);
      return;
    }

    // Re-check via cookie-authenticated /auth/me — no localStorage read.
    let active = true;
    const verifyCookieSession = async () => {
      try {
        const verifiedUser = await refreshUser();
        if (active) setValidSession(Boolean(verifiedUser));
      } catch (err) {
        if (active) setValidSession(false);
      } finally {
        if (active) setAuthChecked(true);
      }
    };
    verifyCookieSession();
    return () => { active = false; };
  }, [loading, isAuthenticated, refreshUser]);

  if (loading || !authChecked) {
    return (
      <div className="min-h-screen bg-pp-bg flex items-center justify-center" data-testid="protected-route-loading">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-2 border-pp-navy border-t-transparent rounded-full animate-spin" />
          <p className="text-pp-text-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated || validSession) {
    return children;
  }

  return <Navigate to="/login" state={{ from: location }} replace />;
}
